import { PageRouteSetTokenCallback } from "@CommonApi/auth/sso/callback";

export const pages = {
  login: "/login",
  setTokenCallback: PageRouteSetTokenCallback,
  logout: "/logout",
  home: "/",
  categories: "/categories",
  categories_categoryId_decisionTrees: "/categories/:categoryId/decision-trees",
  categories_categoryId_cdtStudioConfiguration: "/categories/:categoryId/cdt-studio-configuration",
  categories_categoryId_storeFixtures: "/categories/:categoryId/store-fixtures",
  products: "/products",
  fixtures: "/fixtures",
  projects: "/projects",
  projects_projectId_pogsets: "/projects/:projectId/pogsets",
  playground: "/playground",
  freezer: "/freezer",
  icons: "/icons",
  merchflows: "/merchflows",
  merchflows_merchflowId_S0_s0UserTriggerId_: "/merchflows/:merchflowId/s0/:s0UserTriggerId",
  merchflows_merchflowId_S1_s1UserTriggerId_Templates:
    "/merchflows/:merchflowId/s1/:s1UserTriggerId/templates",
  merchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_:
    "/merchflows/:merchflowId/s1/:s1UserTriggerId/templates/:templateId",
  merchflows_merchflowId_S2Solution_s2SolutionId_:
    "/merchflows/:merchflowId/s2-solution/:s2SolutionId",
  merchflows_merchflowId_S2Templates_templateId_:
    "/merchflows/:merchflowId/s2/templates/:templateId",
  merchflows_merchflowId_S2_s2SolutionId_: "/merchflows/:merchflowId/s2/:s2SolutionId",
  merchflows_merchflowId_BasePog_basePogId_: "/merchflows/:merchflowId/base-pog/:basePogId",
  merchflows_merchflowId_Stores: "/merchflows/:merchflowId/stores",
  merchflows_merchflowId_StoresAll: "/merchflows/:merchflowId/stores/all",
  merchflows_merchflowId_Stores_storeCode_: "/merchflows/:merchflowId/stores/:storeCode",
  merchflows_merchflowId_Stores_storeCode_Pogs_storePogId_:
    "/merchflows/:merchflowId/stores/:storeCode/pogs/:storePogId",
  merchflowTemplates: "/merchflows/:merchflowId/templates",
  merchflowTemplateBasePogs: "/merchflows/:merchflowId/templates/:templateId",
  merchflowsPogThumbnail_basePogId_: "/merchflows/pog-thumbnail/base-pog/:basePogId",
  merchflowsPogThumbnail_storePogId_: "/merchflows/pog-thumbnail/store-pog/:storePogId",
  merchflowsPogExportPdf_storePogId_: "/merchflows/export-pdf/store-pog/:storePogId",
  merchflowsPogExportPdf_basePogId_: "/merchflows/export-pdf/base-pog/:basePogId",
  storeViewer_storePogId_: "/store-viewer/store-pog/:storePogId",
  stores: "/stores",
  stores_storeId_Products: "/stores/:storeId/products",
  categories_categoryId_stores_storeId_Fixtures: "/categories/:categoryId/stores/:storeId/fixtures",
  storeSummary: "/store-summary",
  users: "/users",
  profile: "/profile",
  settings: "/settings",

  imagine: "/imagine",
  imagineShelvesCategories_categoryId_: "/imagine/shelves/categories/:categoryId",
  imagineMacrospace: "/imagine/macrospace",
  imagineAssortment: "/imagine/assortment",
  imagineShelvesFixturesGuessing_fixturesGuessingId_:
    "/imagine/shelves/fixtures-guessing/:fixturesGuessingId",
  merchflows_merchflowId_UpdateReport_storePogTriggerId:
    "/merchflows/:merchflowId/update-report/:storePogTriggerId",

  controlPanel: "/control-panel",
  microspaceAnalysis: "/microspace-analysis",
  assortmentSimulation: "/assortment-simulation",
  assortmentSimulationDetail: "/assortment-simulation/detail/:simulationId",
  auditLogs: "/audit-logs",
  spacePlanning: "/space-planning",
  spacePlanningReview: "/space-planning/review",
  planograms: "/planograms",
  psaRenderer: "/psa-renderer",
  distributionPlanner: "/distribution-planner",
  cdtTreeEditor: "/cdt-tree-editor",
  accessDenied: "/access-denied",
};
